import Cookies from 'js-cookie'

const cookieManager = Cookies.withConverter({
  read: value => value && unescape(value),
})

const getCookieDomain = (appDomain: string) => (appDomain === 'localhost' ? appDomain : `.${appDomain}`)

const deleteAuth = (customerCookieName: string) => () => {
  deleteCookie(customerCookieName)
}

const deleteCustomerCookie = (customerCookieName: string) => () => {
  deleteCookie(customerCookieName)
}

const createCookie =
  (appDomain: string) =>
  (name: string, value: string, days?: number): void => {
    const domain = getCookieDomain(appDomain)
    cookieManager.set(name, value, { expires: days, path: '/', domain, secure: true })
  }

const getCookie = (name: string): string | null => cookieManager.get(name) || null

const deleteCookie =
  (appDomain: string) =>
  (name: string): void => {
    const domain = getCookieDomain(appDomain)

    cookieManager.remove(name, { path: '/', domain })
  }

const deleteAllCookies = (appDomain: string) => (): void => {
  const domain = getCookieDomain(appDomain)

  Object.keys(Cookies.get()).forEach(cookieName => Cookies.remove(cookieName, { path: '/', domain }))
}

export default (appDomain: string, customerCookieName: string) => ({
  deleteAuth: deleteAuth(customerCookieName),
  deleteCustomerCookie: deleteCustomerCookie(customerCookieName),
  createCookie: createCookie(appDomain),
  getCookie,
  deleteCookie: deleteCookie(appDomain),
  deleteAllCookies: deleteAllCookies(appDomain),
})
